var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgOverlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 944,
    height: 48,
    viewBox: "0 0 944 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 944,
    height: 48,
    transform: "matrix(1 0 0 -1 0 48)",
    fill: "url(#paint0_linear_16455_290768)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16455_290768",
    x1: 472,
    y1: 0,
    x2: 472,
    y2: 48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FAFAFC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAFAFC",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOverlay);
export default __webpack_public_path__ + "static/media/overlay.a327b8906a822f6c689fc3adde28361a.svg";
export { ForwardRef as ReactComponent };